var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container_error",class:{error: _vm.fields[_vm.name].errorId}},[_c('div',{staticClass:"editor"},[_c('textarea',{attrs:{"id":_vm.editorId,"name":_vm.editorId}})]),_vm._v(" "),_c('div',{staticClass:"invalid_text"},[_vm._v(_vm._s(_vm.fields[_vm.name].errors[_vm.fields[_vm.name].errorId]))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18b8e323","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/create-form/TextEditor.vue
// module id = null
// module chunks = 